import React, { useEffect, useState } from "react";
import { api, formatIDR } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";

export default function Customers() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => { api.get("/customers").then((r) => setItems(r.data)); }, []);

  const openDetail = async (email) => {
    const r = await api.get(`/customers/${encodeURIComponent(email)}`);
    setSelected(r.data);
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold" style={{ fontFamily: "Outfit" }}>Customers</h1>
      <Card className="border-zinc-200">
        <CardContent className="p-0">
          <Table data-testid="customers-table">
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead>
                <TableHead>Email</TableHead>
                <TableHead>Phone</TableHead>
                <TableHead>Orders</TableHead>
                <TableHead>Events</TableHead>
                <TableHead>Since</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {items.map((c) => (
                <TableRow key={c.email} onClick={() => openDetail(c.email)} className="cursor-pointer" data-testid={`customer-row-${c.email}`}>
                  <TableCell>{c.name}</TableCell>
                  <TableCell className="text-xs">{c.email}</TableCell>
                  <TableCell className="text-xs">{c.phone}</TableCell>
                  <TableCell><Badge variant="outline">{c.orders}</Badge></TableCell>
                  <TableCell><Badge variant="outline">{c.reservations}</Badge></TableCell>
                  <TableCell className="text-xs text-zinc-500">{c.created_at?.slice(0, 10)}</TableCell>
                </TableRow>
              ))}
              {!items.length && <TableRow><TableCell colSpan={6} className="text-center py-10 text-zinc-500">No customers yet.</TableCell></TableRow>}
            </TableBody>
          </Table>
        </CardContent>
      </Card>

      <Dialog open={!!selected} onOpenChange={(o) => !o && setSelected(null)}>
        <DialogContent className="max-w-2xl">
          {selected && (
            <>
              <DialogHeader><DialogTitle>{selected.name}</DialogTitle></DialogHeader>
              <div className="space-y-4 text-sm">
                <p className="text-xs text-zinc-500">{selected.email} · {selected.phone}</p>
                <div>
                  <p className="text-xs uppercase text-zinc-500 mb-2">Bean Orders ({selected.order_history?.length || 0})</p>
                  <ul className="space-y-1">
                    {selected.order_history?.map((o) => (
                      <li key={o.id} className="flex justify-between border-b border-zinc-100 py-1">
                        <span className="font-mono text-xs">{o.order_number}</span>
                        <span>{o.created_at.slice(0, 10)}</span>
                        <span className="font-mono">{formatIDR(o.total)}</span>
                        <Badge variant="outline">{o.status}</Badge>
                      </li>
                    ))}
                  </ul>
                </div>
                <div>
                  <p className="text-xs uppercase text-zinc-500 mb-2">Events ({selected.reservation_history?.length || 0})</p>
                  <ul className="space-y-1">
                    {selected.reservation_history?.map((r) => (
                      <li key={r.id} className="flex justify-between border-b border-zinc-100 py-1">
                        <span className="font-mono text-xs">{r.booking_number}</span>
                        <span>{r.event_date}</span>
                        <span>{r.event_type}</span>
                        <Badge variant="outline">{r.status}</Badge>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
